import { configureStore } from "@reduxjs/toolkit";

import rootReducer from "@/store/root";

export default configureStore({
  reducer: rootReducer,
});
